/**
 * Find the initialized player owned directly by a Video module content box.
 */
export const getFitvidsIframe = (element: HTMLElement): HTMLIFrameElement | null => {
  const iframe = element.querySelector('iframe');
  const wrapper = iframe?.parentElement;

  return iframe &&
    wrapper?.classList.contains('fluid-width-video-wrapper') &&
    wrapper.parentElement === element &&
    1 === element.childElementCount
    ? iframe
    : null;
};
